import { Pipe, PipeTransform } from '@angular/core';
import {GroupByPipe, ValuesPipe} from "ngx-pipes";

@Pipe({
  name: 'groupByValues'
})
export class GroupByValuesPipe implements PipeTransform {

  constructor(private groupByPipe: GroupByPipe, private valuesPipe: ValuesPipe) {
  }

  transform<T>(input: T[], discriminator?: any, delimiter?: string): Array<Array<T>> {
    let transform = this.groupByPipe.transform(input, discriminator, delimiter);
    return this.valuesPipe.transform(transform) as Array<Array<T>>;
  }

}
